export const ADVISORS_MATCH_BASE_URL = 'https://advisorsmatch.nerdwallet.com/find-my-advisor';

export function buildAdvisorMatchPathUrl(path: string, params?: Record<string, string>): string {
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  const url = new URL(`${ADVISORS_MATCH_BASE_URL}/${normalizedPath}`);

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
  }

  return url.toString();
}
